import React, { memo, useContext } from 'react';
import { LinkProps } from '../../../../interfaces/LinkProps.interface';
import { withBlokWrapper } from '../../../BlokWrapper/BlokWrapper';
import { Theme } from '../../../../interfaces/enums/Theme.enum';
import Grid from '../../../Utils/Grid/Grid';
import Col from '../../../Utils/Col/Col';
import ButtonLink from '../../../ButtonLink/ButtonLink';
import { ButtonType } from '../../../../interfaces/enums/ButtonType.enum';
import { ButtonSize } from '../../../../interfaces/enums/ButtonSize.enum';
import { getQueryParam } from '../../../../utils/getQueryParam/getQueryParam.util';
import { postQuoteOverviewToDataLayer } from '../../../../utils/postQuoteOverviewToDataLayer/postQuoteOverviewToDataLayer.util';
import { QuoteContext } from '../../../../contexts/Quote';

interface QuoteButtonsBarProps {
  primary_cta: LinkProps[];
  secondary_cta: LinkProps[];
}

const QuoteButtonsBar: React.FC<QuoteButtonsBarProps> = ({
  primary_cta,
  secondary_cta,
}) => {
  const quoteReference = getQueryParam('quotation');
  const trackingRef = getQueryParam('TrackingRef');

  return (
    <div className="px-10 py-8">
      <Grid>
        <Col span={{ sm: 6 }}>
          {secondary_cta.map((cta: LinkProps) => (
            <ButtonLink
              key={cta._uid}
              url={String(cta.link)
                .replace(/\{quoteReference\}/g, quoteReference!)
                .replace(/\{trackingRef\}/g, trackingRef!)}
              label={cta.label}
              type={ButtonType.TERTIARY}
              size={ButtonSize.XL}
              className="w-full"
            >
              {cta.label}
            </ButtonLink>
          ))}
        </Col>
        <Col span={{ sm: 6 }}>
          {primary_cta.map((cta: LinkProps) => (
            <ButtonLink
              key={cta._uid}
              label={cta.label}
              type={ButtonType.PRIMARY}
              size={ButtonSize.XL}
              className="w-full"
              btnType="submit"
            >
              {cta.label}
            </ButtonLink>
          ))}
        </Col>
      </Grid>
    </div>
  );
};

export default memo(withBlokWrapper(QuoteButtonsBar, Theme.DARKEST));
